var map = {
	"./888.png": "110a",
	"./888_btc.png": "33be",
	"./888_eur.png": "9b83",
	"./888_usd.png": "b252",
	"./aconcagua.png": "341a",
	"./aconcagua_btc.png": "b2c9",
	"./aconcagua_eur.png": "0c0a",
	"./aconcagua_usd.png": "0155",
	"./acr_btc.png": "5a95",
	"./acr_eur.png": "3b1b",
	"./acr_usd.png": "b262",
	"./agribank_btc.png": "0cfa",
	"./agribank_eur.png": "7982",
	"./agribank_usd.png": "fbf9",
	"./betfair.png": "cc15",
	"./betfair_btc.png": "4adf",
	"./betfair_eur.png": "2581",
	"./betfair_usd.png": "650f",
	"./betonline.png": "b76b",
	"./betonline_btc.png": "cb84",
	"./betonline_eur.png": "a18b",
	"./betonline_usd.png": "17ab",
	"./blackchippoker_btc.png": "ccd0",
	"./blackchippoker_eur.png": "4a4b",
	"./blackchippoker_usd.png": "a1d4",
	"./bodog.png": "d4a0",
	"./bodog_btc.png": "98e9",
	"./bodog_eur.png": "43cf",
	"./bodog_usd.png": "91a2",
	"./championpoker_btc.png": "3673",
	"./championpoker_eur.png": "f00e",
	"./championpoker_usd.png": "6a70",
	"./chico.png": "6601",
	"./chico_btc.png": "c3d9",
	"./chico_eur.png": "99be",
	"./chico_usd.png": "d1db",
	"./coinbase_btc.png": "8662",
	"./coinbase_eur.png": "6091",
	"./coinbase_usd.png": "ae53",
	"./cristalpoker.png": "7f89",
	"./cristalpoker_btc.png": "e431",
	"./cristalpoker_eur.png": "8ebf",
	"./cristalpoker_usd.png": "0773",
	"./ecopayz.png": "d59c",
	"./ecopayz_btc.png": "e30f",
	"./ecopayz_eur.png": "e7f6",
	"./ecopayz_usd.png": "d783",
	"./esc_btc.png": "7b1f",
	"./esc_eur.png": "b887",
	"./esc_usd.png": "4637",
	"./gg.png": "0824",
	"./gg_btc.png": "cb4b",
	"./gg_eur.png": "ece9",
	"./gg_usd.png": "4b9c",
	"./ignitioncasino_btc.png": "7eca",
	"./ignitioncasino_eur.png": "921b",
	"./ignitioncasino_usd.png": "ed91",
	"./ipoker.png": "d404",
	"./ipoker_btc.png": "deae",
	"./ipoker_eur.png": "dd5b",
	"./ipoker_usd.png": "8bff",
	"./j88_btc.png": "a85d",
	"./j88_eur.png": "4e8c",
	"./j88_usd.png": "bf6e",
	"./j88poker.png": "4cc7",
	"./live.png": "4b9f",
	"./luxon_eur.png": "8856",
	"./luxon_usd.png": "07c7",
	"./luxon_usdt.png": "0f83",
	"./microgaming.png": "1b2a",
	"./microgaming_btc.png": "4f85",
	"./microgaming_eur.png": "e94d",
	"./microgaming_usd.png": "515e",
	"./millennium_eur.png": "eda4",
	"./muchbetter_btc.png": "730b",
	"./muchbetter_eur.png": "efb0",
	"./muchbetter_usd.png": "78ef",
	"./n26.png": "ae87",
	"./n26_btc.png": "f556",
	"./n26_eur.png": "ff68",
	"./n26_usd.png": "3615",
	"./natural8.png": "3ab5",
	"./natural8_btc.png": "6e97",
	"./natural8_eur.png": "6d92",
	"./natural8_usd.png": "261d",
	"./neteller.png": "bc0e",
	"./neteller_btc.png": "7933",
	"./neteller_eur.png": "28e1",
	"./neteller_usd.png": "7f65",
	"./partypoker.png": "0238",
	"./partypoker_btc.png": "029e",
	"./partypoker_eur.png": "7b90",
	"./partypoker_usd.png": "cf12",
	"./pokerking_btc.png": "dee9",
	"./pokerking_eur.png": "53e9",
	"./pokerking_usd.png": "d9d1",
	"./pokerok.png": "cf5b",
	"./pokerok_btc.png": "9f57",
	"./pokerok_eur.png": "c35d",
	"./pokerok_usd.png": "b594",
	"./pokerstars.png": "64a5",
	"./pokerstars_btc.png": "42d4",
	"./pokerstars_eur.png": "918f",
	"./pokerstars_usd.png": "97b0",
	"./ppipoker_btc.png": "64f5",
	"./ppipoker_eur.png": "a80e",
	"./ppipoker_usd.png": "8209",
	"./pppoker.png": "1f38",
	"./pppoker_btc.png": "edb4",
	"./pppoker_eur.png": "bf73",
	"./pppoker_usd.png": "a082",
	"./revolut_btc.png": "54cf",
	"./revolut_eur.png": "8440",
	"./revolut_usd.png": "c46f",
	"./revolution_btc.png": "c1a9",
	"./revolution_eur.png": "597f",
	"./revolution_usd.png": "937c",
	"./skrill.png": "66d1",
	"./skrill_btc.png": "cbfe",
	"./skrill_eur.png": "4f33",
	"./skrill_usd.png": "1d63",
	"./tiger_btc.png": "9c72",
	"./tiger_eur.png": "7a66",
	"./tiger_usd.png": "9880",
	"./tigergaming.png": "c526",
	"./unibet.png": "e869",
	"./unibet_btc.png": "577b",
	"./unibet_eur.png": "7ee0",
	"./unibet_usd.png": "cfeb",
	"./winamax.png": "d04f",
	"./winamax_btc.png": "2a3d",
	"./winamax_eur.png": "2bd2",
	"./winamax_usd.png": "9b05",
	"./withdraw.png": "8b83",
	"./withdraw_btc.png": "2877b",
	"./withdraw_eur.png": "53a7",
	"./withdraw_lg.png": "9a29",
	"./withdraw_usd.png": "e9c1",
	"./wpn.png": "a9b0",
	"./wpn_btc.png": "0d94",
	"./wpn_eur.png": "96eb",
	"./wpn_usd.png": "64db",
	"./wpt.png": "393b",
	"./wpt_btc.png": "dc26",
	"./wpt_eur.png": "c76b",
	"./wpt_usd.png": "a4a8",
	"./wsop_btc.png": "38c0",
	"./wsop_eur.png": "db7e",
	"./wsop_usd.png": "f6b8",
	"./yapoker_btc.png": "3043",
	"./yapoker_eur.png": "d77a",
	"./yapoker_usd.png": "8a39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9dd";